import type { Dictionary } from './ru';

/** Узбекский (кириллица). Ключи и сигнатуры функций — те же, что в ru.ts. */
export const uz: Dictionary = {
  app: { title: 'Debt Bot' },
  notInTelegram: {
    title: 'Telegram орқали очинг',
    body: 'Бу илова Telegram ичида ишлайди. Ботни очиб, «Иловани очиш»ни босинг.',
    openBot: 'Ботни очиш',
  },
  botMoved: {
    title: 'Бот кўчиб ўтди',
    body: (bot: string) => `Энди бу @${bot}. Барча қарзларингиз ва дўстларингиз ўша ерда.`,
    open: 'Янги ботни очиш',
  },
  home: {
    title: 'Қарзлар',
    owedToMe: 'Менга қарз',
    iOwe: 'Мен қарздорман',
    invite: 'Таклиф қилиш',
    add: 'Қўшиш',
    emptyTitle: 'Биринчи дўстингизни таклиф қилинг',
    emptyBody: 'Унга ҳаволани юборинг — қабул қилгач, умумий балансни кўрасиз.',
    disputed: (n: number) => (n === 1 ? '1 баҳсли' : `${n} баҳсли`),
    disputedAmount: 'Баҳсли',
    deletedUser: 'Ўчирилган фойдаланувчи',
    shareText:
      'Келинг, ҳисоб-китобимизни Kvits’да юритамиз — ким кимга қанча, чалкашмаслик учун. Очинг — ёзувни кўрасиз.',
    inviteLimit: 'Юборилмаган таклифлар жуда кўп. Яратилганларини юборинг ёки кутиб туринг.',
    shareDraftIPaid: (sum: string, note: string | null) =>
      `Kvits’га ёзиб қўйдим: сен → менга ${sum}${note ? `, ${note}` : ''}. Очиб тасдиқла — иккимизга ҳам кўринади.`,
    shareDraftPeerPaid: (sum: string, note: string | null) =>
      `Kvits’га ёзиб қўйдим: мен → сенга ${sum}${note ? `, ${note}` : ''}. Оч — иккимизга ҳам кўринади.`,
    draftTitle: 'Биринчи ёзув',
    draftWhoPaid: 'Ким тўлади?',
    draftMe: 'Мен',
    draftPeer: 'У',
    draftSend: 'Юбориш',
    draftSkip: 'Ўтказиб юбориш',
    linkTitle: 'Таклиф ҳаволаси',
    copy: 'Нусхалаш',
    copied: 'Нусхаланди',
    copyFailed: 'Нусхалаб бўлмади — ҳаволани қўлда белгиланг.',
    settings: 'Созламалар',
    search: 'Исм бўйича қидириш',
    nothingFound: 'Ҳеч ким топилмади',
  },
  onboarding: {
    /** Латиница по продуктовой формулировке, остальной словарь — кириллица. */
    title: 'Hozir kim bilan yopilmagan qarzingiz bor?',
    body: 'Ёзиб қўйинг — ва унга юборинг. Ёзувни фақат иккингиз кўрасиз.',
    cta: 'Ёзиш ва юбориш',
    skip: 'Ҳозирча шунчаки кўриш',
    pendingTitle: 'Кутилмоқда',
    pendingLink: (date: string) => `${date} даги ҳавола`,
    resend: 'Яна юбориш',
    newLink: 'Янги ҳавола яратиш',
    newLinkHint: 'Эски ҳавола бекор қилинмайди ва ишлашда давом этади.',
    inviteAnother: 'Бошқасини таклиф қилиш',
  },
  pick: { title: 'Кимга қўшамиз?', empty: 'Аввал дўстингизни таклиф қилинг.' },
  person: {
    owesYou: (name: string) => `${name} сизга қарздор`,
    youOwe: (name: string) => `Сиз ${name}га қарздорсиз`,
    settled: 'Қарз йўқ',
    quickAdd: 'Тез қўшиш',
    add: 'Қўшиш',
    settle: 'Қарзни ёпиш',
    emptyFeed: 'Ҳозирча амаллар йўқ. Биринчисини қўшинг.',
    loadMore: 'Яна кўрсатиш',
    added: 'Қўшилди',
    undo: 'Бекор қилиш',
    peerDeleted: 'Бу фойдаланувчи аккаунтини ўчирган. Янги амаллар мумкин эмас.',
  },
  form: {
    newTitle: 'Янги амал',
    editTitle: 'Амални таҳрирлаш',
    iPaid: 'Мен тўладим',
    peerPaid: (name: string) => `${name} тўлади`,
    note: 'Изоҳ (ихтиёрий)',
    add: (sum: string) => `Қўшиш · ${sum}`,
    addEmpty: 'Қўшиш',
    save: 'Сақлаш',
    bigAmount: 'Суммани текширинг — 100 млн дан кўп',
    maxAmount: 'Сумма жуда катта',
  },
  settle: {
    title: 'Қарзни ёпиш',
    full: (sum: string) => `Тўлиқ · ${sum}`,
    other: 'Бошқа сумма',
    confirm: (sum: string) => `${sum} ёпиш`,
    direction: (payer: string, receiver: string) => `Ким қайтарди: ${payer} → ${receiver}`,
    me: 'мен',
    toMe: 'менга',
    changed: (sum: string) => `Баланс ўзгарди: энди ${sum}. Яна босинг.`,
    overpay: (sum: string) => `Бу қарздан кўп — баланс тескари томонга ${sum} бўлади`,
  },
  tx: {
    title: 'Амал',
    disputed: 'баҳсли',
    edited: 'таҳрирланган',
    deleted: 'Амал ўчирилган',
    paidFor: (payer: string, beneficiary: string) => `${payer} ${beneficiary} учун тўлади`,
    returned: (payer: string, receiver: string) => `${payer} ${receiver}га қайтарди`,
    addedBy: (name: string) => `${name} қўшди`,
    history: 'Тарих',
    edit: 'Таҳрирлаш',
    delete: 'Ўчириш',
    dispute: 'Баҳслашиш',
    withdraw: 'Баҳсни олиб ташлаш',
    confirmDelete: 'Амал ўчирилсинми? Иккинчи томон хабар олади.',
    disputeTitle: 'Амални баҳслашиш',
    disputeHint: 'Келишгунингизча сумма балансдан чиқарилади. Муаллиф хабар олади.',
    disputeReason: 'Изоҳ (ихтиёрий)',
    disputeReasonBy: (name: string) => `${name}: `,
    events: {
      CREATED: 'Яратилди',
      UPDATED: 'Таҳрирланди',
      DELETED: 'Ўчирилди',
      DISPUTED: 'Баҳслашилди',
      DISPUTE_WITHDRAWN: 'Баҳс олиб ташланди',
    } as Record<string, string>,
    fields: {
      amount: 'Сумма',
      payer_id: 'Ким тўлади',
      category: 'Категория',
      note: 'Изоҳ',
      dispute_cleared: 'Таҳрирдан сўнг баҳс олиб ташланди',
    } as Record<string, string>,
  },
  invite: {
    offer: (name: string) => `${name} ҳисоб-китобни бирга юритишни таклиф қилмоқда`,
    body: 'Ёзувларни фақат иккингиз кўрасиз.',
    recorded: (name: string) => `${name} ёзиб қўйди`,
    youToName: (name: string) => `Сен → ${name}`,
    nameToYou: (name: string) => `${name} → сен`,
    accept: 'Қабул қилиш',
    decline: 'Рад этиш',
    self: 'Бу сизнинг ҳаволангиз — дўстингизга юборинг.',
    expired: 'Ҳавола эскирган.',
    used: 'Ҳавола аллақачон ишлатилган.',
    notFound: 'Ҳавола топилмади.',
    alreadyConnected: (name: string) => `Сиз ${name} билан аллақачон боғлангансиз.`,
    open: 'Очиш',
    inviterGone: 'Таклиф муаллифи аккаунтини ўчирган.',
  },
  settings: {
    title: 'Созламалар',
    languageAuto: 'Telegram’дагидек',
    languageRu: 'Русский',
    languageUz: 'Ўзбекча',
    notifications: 'Янги ва таҳрирланган амаллар ҳақида хабарлар',
    notificationsHint: 'Ўчириш, баҳс ва қабул қилинган таклифлар ҳақида доим хабар берамиз.',
    language: 'Тил',
    version: 'Версия',
    deleteAccount: 'Аккаунтни ўчириш',
    deleteHint: 'Ўчириш ботда бажарилади: уни очиб, /settings юборинг.',
    openBot: 'Ботни очиш',
    feedback: 'Таклиф юбориш',
    feedbackHint: 'Ғоялар, нима ноқулай, нима етишмайди',
  },
  feedback: {
    title: 'Таклиф юбориш',
    body: 'Нимани қўшиш ёки тузатиш кераклигини ёзинг. Хабар ишлаб чиқувчига Telegram’да боради.',
    placeholder: 'Таклифингиз',
    send: 'Юбориш',
    sent: 'Раҳмат! Таклиф юборилди',
    tooOften: 'Хабарлар жуда кўп. Бир соатдан кейин уриниб кўринг.',
  },
  errors: {
    network: 'Алоқа йўқ. Интернетни текшириб, яна уриниб кўринг.',
    generic: 'Нимадир хато кетди.',
    retry: 'Қайта уриниш',
    conflict: 'Амал ўзгартирилган. Маълумотлар янгиланди — текшириб, қайта уриниб кўринг.',
  },
  common: {
    loading: 'Юкланмоқда…',
    on: 'Ёқилган',
    off: 'Ўчирилган',
    back: 'Орқага',
    home: 'Бош саҳифага',
    cancel: 'Бекор қилиш',
  },
  date: {
    today: 'бугун',
    yesterday: 'кеча',
    months: ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
  },
  txKind: { settlement: 'Қайтариш', expense: 'Харажат' },
};
